<template>
  <div
    :style="{
      backgroundColor: isDarkTheme ? mainBgColor : '#eeeeee',
      paddingBottom: '10px'
    }"
    id="referrals"
  >
    <header-o :model="headerData"></header-o>
    <div
      class="margin-vertical-10"
      :style="[
        isGamification ? { 'margin-top': '-70px' } : { 'margin-top': '-95px' }
      ]"
    >
      <div
        :style="{
          backgroundColor: isDarkTheme ? shadowBgColor : '#ffffff',
          borderRadius: '10px',
          color: isDarkTheme ? subHeadingTextColor : '#000000',
          marginTop: '10px'
        }"
        class="bg-light bottom-radius-5 box-shadow margin-bottom-10"
      >
        <div
          class="align-hor center-ver space-between padding-10 bottom-border"
          v-if="referralHistoryData.refer_code"
        >
          <div class="align-hor center-ver flex-09">
            <div
              class="radius50 align-hor center-ver center-hor opc-80 margin-right-10"
              style="width: 35px; height: 35px;"
              :style="{ backgroundColor: isDarkTheme ? topBgColor : bgTheme }"
            >
              <img class="smaller-icon" src="@/assets/share.svg" />
            </div>
            <div class="text-left">
              <div class="text-medium font-bold">
                {{ referralHistoryData.refer_code }}
              </div>
              <div class="text-small">Your referral code</div>
            </div>
          </div>
          <div class="align-ver center-ver pointer">
            <div
              class="text-regular"
              :style="{ color: isDarkTheme ? lightTopBgColor : bgTheme }"
              @click="getShareMsg(null, 'cp')"
            >
              Share
            </div>
          </div>
        </div>

        <div style="padding: 10px;">
          <div
            :style="{
              backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff',
              marginBottom: '10px',
              borderRadius: '10px',
              padding: '0px 10px'
            }"
            class="referral"
            v-for="referral in referralHistoryData.referrals"
          >
            <div class="align-hor center-ver space-between padding-10">
              <div class="align-ver center-hor">
                <div class="text-left font-bold text-large margin-bottom-5">
                  {{ referral.user_name }}
                </div>
                <div class="text-left align-hor center-ver">
                  <img
                    class="smaller-icon margin-right-5"
                    :src="referral.currency_icon_url"
                  />
                  <div class="text-semi-small">
                    {{ referral.total_amount_won }}
                  </div>
                </div>
              </div>
              <div v-if="referral.remind_user">
                <button
                  class="custom-button padding-0510 text-semi-small radius-3 pointer"
                  :style="{
                    backgroundColor: isDarkTheme ? buttonBGColor : bgTheme,
                    color: isDarkTheme ? headingTextColor : '#ffffff'
                  }"
                  v-if="referral.enable_remind_button"
                  style="min-width: 70px;"
                  @click="sendReminder(referral)"
                >
                  Remind
                </button>
                <button
                  class=" custom-button padding-0510 text-semi-small radius-3"
                  :style="{ backgroundColor: '#efefef' }"
                  style="min-width: 70px;"
                  v-else
                >
                  Remind
                </button>
              </div>
            </div>
            <div style="border-top: 1px dotted gray;" class="referrals-wrapper">
              <div
                class="align-hor pos-rel"
                style="display: flex; align-content: flex-start;  width: auto; transform: translate(0, 0);"
              >
                <div
                  class="referral-db-wrapper db-wrapper align-ver center-ver padding-right-5"
                  style="width: 70px;"
                  v-for="event in referral.offer_events"
                >
                  <div
                    class="text-left align-hor center-ver margin-bottom-5 padding-0305 radius-30"
                    style="width: max-content; border: 1px solid #ffffff;"
                    v-if="event.id > 0"
                  >
                    <img
                      class="extra-small-icon margin-right-5"
                      :src="referral.currency_icon_url"
                    />
                    <div class="text-smaller" v-if="event.reward_value">
                      {{ event.reward_value }}
                    </div>
                    <div
                      class="text-smaller"
                      v-else-if="
                        event.min_reward_referrer > 0 &&
                          event.min_reward_referrer > 0
                      "
                    >
                      <div
                        v-if="
                          event.min_reward_referrer == event.max_reward_referrer
                        "
                      >
                        {{ event.min_reward_referrer }}
                      </div>
                      <div v-else>
                        {{ event.min_reward_referrer }}-{{
                          event.max_reward_referrer
                        }}
                      </div>
                    </div>
                    <div class="text-smaller" v-else>
                      Upto {{ event.max_reward_referrer }}
                    </div>
                  </div>
                  <div
                    style="opacity: 0;"
                    class="text-left align-hor center-ver bg-light-grey margin-bottom-5 padding-0305 radius-30"
                    v-else
                  >
                    <img
                      class="extra-small-icon margin-right-5"
                      :src="referral.currency_icon_url"
                    />
                    <div class="text-smaller" v-if="event.reward_value">
                      {{ event.reward_value }}
                    </div>
                  </div>

                  <div class="dotted-bg margin-bottom-5">
                    <div
                      class="radius50 bg-light padding-4 align-hor center-ver center-hor"
                      style="width: 14px; height: 14px;"
                      :style="{
                        background: `${
                          isDarkTheme ? shadowBgColor : bgTheme
                        } !important`
                      }"
                      v-if="event.is_completed"
                    >
                      <div class="check-mark"></div>
                    </div>
                    <div
                      class="radius50  padding-4"
                      style="border: 1px solid #6D6666; background-color: transparent;"
                      v-else
                    >
                      <div
                        class="radius50"
                        style="width: 12px; height: 12px; cursor: pointer;"
                        :style="{
                          background: isDarkTheme ? shadowBgColor : bgTheme
                        }"
                        @click="triggerToast"
                      ></div>
                    </div>
                  </div>
                  <div class="text-small">{{ event.name }}</div>
                  <div class="line-btw"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="no-referral" v-if="noReferralsPresent">
          No referrals yet!
        </div>

        <div
          id="copied-toast"
          class="font-bold pos-fixed pos-center-hor pull-down"
          style="width: 100px; padding: 5px; border-radius: 10px; background: rgba(0, 0, 0, 0.3); margin-bottom: 70px; color: white; display: none;"
        >
          Link Copied
        </div>

        <div>
          <div
            id="copied-toast-1"
            class="font-bold pos-fixed pos-center-hor pull-down"
            style="width: 200px; padding: 5px; border-radius: 10px; background: #000000; margin-bottom: 70px; color: white; display: none;"
          >
            Notification triggered successfully.
          </div>
        </div>

        <div
          id="historydata"
          class="bg-light"
          v-if="referralHistoryData.length == 0"
        >
          <div
            class="align-hor center-ver space-between padding-10 bottom-border"
          >
            <div class="w70">
              <div class="align-hor center-ver">
                <div class="w15 margin-right-10">
                  <div class="wrapper">
                    <div class="comment animate"></div>
                    <div class="comment animate"></div>
                    <div class="comment animate"></div>
                  </div>
                </div>
                <div class="w40">
                  <div class="wrapper">
                    <div class="comment animate margin-bottom-5 w50"></div>
                    <div class="comment animate w85"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="w10">
              <div class="wrapper">
                <div class="comment animate"></div>
                <div class="comment animate"></div>
              </div>
            </div>
          </div>
          <div
            class="align-hor center-ver space-between padding-10 margin-bottom-10"
          >
            <div class="w70">
              <div class="wrapper">
                <div class="comment animate margin-bottom-10 w40"></div>
                <div class="comment animate w20"></div>
              </div>
            </div>
            <div class="w20">
              <div class="wrapper">
                <div class="comment animate"></div>
                <div class="comment animate"></div>
              </div>
            </div>
          </div>
          <div
            class="align-hor center-ver space-between padding-10 bottom-border"
          >
            <div class="wrapper">
              <div class="comment animate"></div>
              <div class="comment animate"></div>
              <div class="comment animate"></div>
            </div>
          </div>
        </div>
        <infinite-loading @infinite="infiniteHandler" ref="infiniteLoading"
          ><span slot="no-more"></span
        ></infinite-loading>
      </div>
    </div>
  </div>
</template>
<script>
import { globals } from "@/mixins/globals";
import axios from "axios";
import OverlapHeader from "@/components/overlapped-header";
import ScratchCard from "@/components/scratch-card";
import BRUSH from "@/assets/brush.png";
import SCBG from "@/assets/sc-bg-empty-circle.svg";
export default {
  mixins: [globals],
  components: {
    "header-o": OverlapHeader,
    "scratch-card": ScratchCard
  },
  data() {
    return {
      headerData: {
        onlyHeader: false,
        rewards: false,
        referrals: true
      },
      page: 1,
      referralHistoryData: [],
      noReferralsPresent: false
    };
  },
  computed: {
    buttonBGColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.buttonBGColor
      ) {
        return this.$store.state.sdkEvent.themeColors.buttonBGColor;
      }
      return null; // fallback
    },
    headingTextColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.headingTextColor
      ) {
        return this.$store.state.sdkEvent.themeColors.headingTextColor;
      }
      return null; // fallback
    },
    isDarkTheme() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDarkTheme &&
        this.$store.state.sdkEvent.isDarkTheme
      ) {
        return this.$store.state.sdkEvent.isDarkTheme;
      }
      return null; // fallback
    },
    lightTopBgColor() {
      if (!this.topBgColor) return null;

      // Convert hex → RGB
      const hex = this.shadowBgColor.replace("#", "");
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);

      // Increase brightness (20% lighter)
      const lighten = value =>
        Math.min(255, Math.floor(value + (255 - value) * 0.2));

      const lr = lighten(r);
      const lg = lighten(g);
      const lb = lighten(b);

      return `rgb(${lr}, ${lg}, ${lb})`;
    },
    isDarkTheme() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDarkTheme &&
        this.$store.state.sdkEvent.isDarkTheme
      ) {
        return this.$store.state.sdkEvent.isDarkTheme;
      }
      return null; // fallback
    },
    subHeadingTextColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.subHeadingTextColor
      ) {
        return this.$store.state.sdkEvent.themeColors.subHeadingTextColor;
      }
      return null; // fallback
    },
    topBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.topBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.topBgColor;
      }
      return null; // fallback
    },
    offersCardBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.shadowBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.offersCardBgColor;
      }
      return null; // fallback
    },
    shadowBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.shadowBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.shadowBgColor;
      }
      return null; // fallback
    },
    mainBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.mainBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.mainBgColor;
      }
      return null; // fallback
    }
  },

  beforeMount() {
    var self = this;
    if (window.addEventListener) {
      window.addEventListener("flyyDataSet", self.refreshRewards, false);
    } else {
      window.attachEvent("onflyyDataSet", self.refreshRewards);
    }
    this.loadDataFromCookie();

    this.$store.state.user.show_currency_name = true; //this.rewardsShowCurrencyName;
    this.$store.state.user.show_currency_list = true; //this.rewardsShowCurrencyList;
  },
  methods: {
    triggerToast() {
      console.log("Toast clicked...");
      const toast = document.getElementById("copied-toast-1");

      toast.style.display = "block";
      toast.style.opacity = "1";

      setTimeout(() => {
        toast.style.opacity = "0";
        setTimeout(() => {
          toast.style.display = "none";
        }, 300);
      }, 2000);
    },
    refreshRewards() {
      this.$refs.infiniteLoading.$emit("$InfiniteLoading:reset");
    },
    infiniteHandler($state) {
      var self = this;
      var url = self.$store.getters.flyyDomain + "/v2/referral_history";
      var headers = self.$store.getters.headers;
      axios
        .get(url, {
          headers: headers,
          params: {
            page: self.page
          }
        })
        .then(resp => {
          if (resp.status == 200) {
            var data = resp.data;
            var tempArr = [];
            if (data.referrals && data.referrals.length > 0) {
              data.referrals.forEach(ref => {
                var has_incomplete = ref.offer_events.filter(v => {
                  return v.is_completed == false;
                });
                if (has_incomplete.length > 0) {
                  ref.enable_remind_button = true;
                } else {
                  ref.enable_remind_button = false;
                }
              });
            }
            this.$store.state.user.referral_balances = data.wallet_data;

            if (data.wallet_data.length > 0) {
              this.$store.state.user.referralWalletData = true;
            } else {
              this.$store.state.user.referralWalletData = false;
            }
            self.referralHistoryData = data;

            if (
              self.referralHistoryData.referrals &&
              self.referralHistoryData.referrals.length > 0
            ) {
              self.noReferralsPresent = false;
            } else {
              self.noReferralsPresent = true;
            }
            $state.loaded();
            $state.complete();
          } else {
            console.log("Error fetching the user offers");
          }
        });
    },
    sendReminder(referral) {
      var offer_id = referral.offer_id;
      var user_id = referral.user_id;
      var event_to_remind = referral.offer_events.filter(v => {
        return v.is_completed == false;
      });

      var event_id =
        event_to_remind.length > 0 ? event_to_remind[0].event_id : "";

      if (!event_id) {
        this.toastPopup(true, "Invalid event");
        return false;
      }

      var data = {
        event_id: event_id,
        offer_id: offer_id,
        user_id: user_id
      };

      var url = this.$store.getters.flyyDomain + "/remind_user";
      var headers = this.$store.getters.headers;

      var options = {
        method: "post",
        url: url,
        headers: headers,
        data: data
      };

      axios(options)
        .then(resp => {
          if (resp.status == 200) {
            var data = resp.data;
            if (data.success) {
              this.toastPopup(true, data.message);
            } else {
              var message = data.message;
              if (window.webkit) {
                window.webkit.messageHandlers.handleMessage.postMessage({
                  action: "share",
                  share_url: "",
                  share_from: "cp",
                  message: message
                });
              } else {
                this.copyToClipboard(message);
              }
              // var message = encodeURIComponent(data.message);
              // window.location = 'whatsapp://send?text='+message;
            }
          } else {
            this.toastPopup(true, resp.data.message);
          }
        })
        .catch(err => {
          console.log("Reminder error!");
        });
    }
  },
  created() {
    this.$store.state.showHeader = false;
    this.$store.state.showWallet = false;
    this.$store.state.showHistory = false;
    this.$store.state.headTitle = "Referrals";
  }
};
</script>
<style>
.line-btw {
  height: 1px;
  width: 100px;
  background-color: #c9cbd3;
  position: absolute;
  top: 32px;
  z-index: -1;
}
.referral-db-wrapper {
  position: relative;
  white-space: normal;
}
.db-wrapper:first-child .line-btw,
.db-wrapper:last-child .line-btw {
  width: 45px;
}
.db-wrapper:first-child .line-btw {
  left: 30px;
}
.db-wrapper:last-child .line-btw {
  right: 35px;
}
.referrals-wrapper .check-mark {
  display: inline-block;
  transform: rotate(45deg);
  width: 3px;
  height: 8px;
  border-bottom: 2px solid #ffffff;
  border-right: 2px solid #ffffff;
}
.referrals-wrapper {
  overflow-y: scroll;
  white-space: nowrap;
  padding: 20px 0px 20px 15px;
  scrollbar-width: none;
}
</style>
